import React from 'react';
import { RectangleSkeleton } from '@sm360/widget-commons-general';
import './InventoryNewTile.scss';

const InventoryNewLoadingTile = () => {
    return (
        <div role="button" tabIndex={0} className="listing-new-tile loading-new-tile">
            <div className="listing-new-tile-image">
                <div className="new-car-image-wrapper">
                    <RectangleSkeleton width={800} height={110} />
                </div>
            </div>

            <div className="listing-new-tile-wrapper">
                <div className="listing-new-tile-drivePowerTrains">
                    <div className="new-car-name sr-text is-bold">
                        <RectangleSkeleton width={150} height={15} />
                    </div>
                    <div className="new-car-motor">
                        <p>
                            <RectangleSkeleton width={60} height={15} />
                        </p>
                        <p>
                            <RectangleSkeleton width={60} height={15} />
                        </p>
                        <p>
                            <RectangleSkeleton width={60} height={15} />
                        </p>
                    </div>
                </div>

                <div className="listing-tiles-payment">
                    <RectangleSkeleton width={800} height={250} />
                </div>
                <div className="listing-tile-vin">
                    <RectangleSkeleton width={120} height={15} />
                </div>
                <div className="listing-new-tile-spec">
                    <div className="listing-tile-specification-wrapper">
                        <RectangleSkeleton width={150} height={100} />
                    </div>
                    <div className="listing-tile-specification-specifics">
                        <RectangleSkeleton width={60} height={15} />
                        <RectangleSkeleton width={100} height={80} />
                    </div>
                </div>
            </div>
        </div>
    );
};

InventoryNewLoadingTile.displayName = 'LoadingTile-A.InventoryNewLoadingTile';

export default InventoryNewLoadingTile;
